import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetInboundMail(status) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/inbound-mail`,
        params: status ? { status } : undefined,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestResolveInboundMail(id, body) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/inbound-mail/${id}/resolve`,
        data: body,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetInboundMailOauthStatus() {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/inbound-mail/oauth/status`,
        withCredentials: true,
        crossorigin: true,
    });
}
